import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createOrganization } from 'features/navigation/actions';
import styles from './styles.module.scss';

class CreateOrganizationModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            organizationName: '',
            isSubmitting: false,
            error: null
        };
    }

    componentDidUpdate(prevProps) {
        // Handle successful creation
        if (prevProps.isCreating && !this.props.isCreating && !this.props.createError) {
            this.props.onClose();
            this.setState({
                organizationName: '',
                isSubmitting: false,
                error: null
            });
        }

        // Handle creation failure
        if (prevProps.isCreating && !this.props.isCreating && this.props.createError) {
            this.setState({
                isSubmitting: false,
                error: this.props.createError
            });
        }
    }

    handleInputChange = (e) => {
        this.setState({
            organizationName: e.target.value,
            error: null // Clear error when user types
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { organizationName } = this.state;

        if (organizationName.trim()) {
            this.setState({
                isSubmitting: true,
                error: null
            });

            // Get client's timezone with fallback
            let timezone = 'UTC'; // Safe default
            try {
                if (typeof Intl !== 'undefined' && Intl.DateTimeFormat) {
                    const detectedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                    // Basic validation - timezone should contain a forward slash
                    if (detectedTimezone && typeof detectedTimezone === 'string' && detectedTimezone.includes('/')) {
                        timezone = detectedTimezone;
                    }
                }
            } catch (error) {
                console.warn('Failed to detect timezone, using UTC:', error);
                // timezone remains 'UTC'
            }

            this.props.createOrganization(organizationName.trim(), timezone);
        }
    }

    handleClose = () => {
        this.setState({
            organizationName: '',
            error: null,
            isSubmitting: false
        });
        this.props.onClose();
    }

    render() {
        const { isOpen } = this.props;
        const { organizationName, isSubmitting, error } = this.state;

        if (!isOpen) return null;

        return (
            <div className={styles.overlay} onClick={this.handleClose}>
                <div className={styles.modal} onClick={e => e.stopPropagation()}>
                    <h2 className={styles.title}>Create Organization</h2>
                    <form onSubmit={this.handleSubmit}>
                        <input
                            type="text"
                            placeholder="Organization Name"
                            value={organizationName}
                            onChange={this.handleInputChange}
                            className={styles.input}
                            autoFocus
                            disabled={isSubmitting}
                        />
                        {error && (
                            <div className={styles.error}>
                                {error}
                            </div>
                        )}
                        <div className={styles.buttonContainer}>
                            <button
                                type="button"
                                onClick={this.handleClose}
                                className={styles.cancelButton}
                                disabled={isSubmitting}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className={styles.createButton}
                                disabled={!organizationName.trim() || isSubmitting}
                            >
                                {isSubmitting ? 'Creating...' : 'Create'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isCreating: state.organization_switcher?.isCreating || false,
        createError: state.organization_switcher?.createError || null
    };
};

const mapDispatchToProps = {
    createOrganization
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateOrganizationModal);